import Swiper from "swiper/dist/js/swiper.js";

export default {
  init() {
    const allButtons = document.querySelectorAll('.serv-btn')
    const allGroups = document.querySelectorAll('.serv-accordion__content__group')
    let allSecondaryButtons = document.querySelectorAll('.other-serv-list__btn')
    const topImage = document.querySelector('.overview__img')
    let activeGroup;

    allButtons.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        item.classList.add('open')
        activeGroup = item.id;
        rewriteUrl(item);
        serviceActive(activeGroup)
        document.querySelector('.serv-accordion__items').style.display = 'none';
        // document.querySelector('.other-serv-list').classList.add('open')
      })
    })

    allSecondaryButtons.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const offsetTop = document.querySelector('#service-accordion-section').offsetTop - 112;

        scroll({
          top: offsetTop,
          behavior: "smooth"
        });
      })
    })

    function serviceActive(service) {
      allGroups.forEach(item => item.classList.remove('open'))

      document.querySelector(`#${service}-content`).classList.add('open')
      document.querySelector(`#service-accordion-section`).classList.add('active')

      topImage.querySelectorAll('.overview__img__inner').forEach(item => item.style.display = 'none')
      topImage.querySelector(`.${service}`).style.display = 'flex'

      // document.querySelectorAll(`.other-serv-list > button`).forEach(item => item.style.display = 'block')
      // document.querySelector(`.other-serv-list > button#${service}`).style.display = 'none'
    }


    let allSwipers = document.querySelectorAll('.serv-accordion__content__swiper')
    allSwipers.forEach(item => {
      new Swiper(item, {
        direction: 'horizontal',
        speed: 400,
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        a11y: true,
        navigation: {
          nextEl: item.parentElement.querySelector('.swiper-button-next'),
          prevEl: item.parentElement.querySelector('.swiper-button-prev')
        }
      });
    })
    let toggleServiceBtn=()=>{
      allButtons.forEach(item => {
        let tgl = item.getAttribute("data-toggle");
        let id = item.getAttribute("id");
        if(tgl){
          item.click();
          console.log(item);
          const acc =  document.querySelector(".serv-accordion.active");
          const hdrOff = document.querySelector(".header").offsetHeight;
          const accPos = acc.getBoundingClientRect().top;
          let oPos = accPos + window.pageYOffset - hdrOff;
  
          if (window.screen.width >= 768) {
            oPos=oPos-60;
          }
          window.scrollTo({
               top: oPos,
               behavior: "smooth"
          });
        }
      })
    }
    let rewriteUrl=(item)=>{
      var tgl_id=item.id;
      let slug = item.getAttribute("data-slug");
      var base = window.location.protocol + '//' + window.location.host +'/'+ slug +'/'+ tgl_id;
      window.history.pushState("", "", base);
    }
    window.onpopstate = function(event) {
      location.reload();
  }
    setTimeout(function(){
      toggleServiceBtn();
    },30)
	},
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
